/**
 * Sidebar Icon
 *
 */

export default function fonts(props = {}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M0.75 12.749H11.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 17.249H23.25"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 21.749V13.5C15.75 12.5054 16.1451 11.5516 16.8483 10.8483C17.5516 10.1451 18.5054 9.75 19.5 9.75C20.4946 9.75 21.4484 10.1451 22.1517 10.8483C22.8549 11.5516 23.25 12.5054 23.25 13.5V21.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 21.749V7.5C0.75 6.10761 1.30312 4.77226 2.28769 3.78769C3.27226 2.80312 4.60761 2.25 6 2.25C7.39239 2.25 8.72774 2.80312 9.71231 3.78769C10.6969 4.77226 11.25 6.10761 11.25 7.5V21.75"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
